const Smile = ({ ...props }) => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.5 15.75C13.2279 15.75 16.25 12.7279 16.25 9C16.25 5.27208 13.2279 2.25 9.5 2.25C5.77208 2.25 2.75 5.27208 2.75 9C2.75 12.7279 5.77208 15.75 9.5 15.75Z"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 9C8.05228 9 8.5 8.55228 8.5 8C8.5 7.44772 8.05228 7 7.5 7C6.94772 7 6.5 7.44772 6.5 8C6.5 8.55228 6.94772 9 7.5 9Z"
      fill="#3F3C43"
    />
    <path
      d="M11.5625 9C12.1148 9 12.5625 8.55228 12.5625 8C12.5625 7.44772 12.1148 7 11.5625 7C11.0102 7 10.5625 7.44772 10.5625 8C10.5625 8.55228 11.0102 9 11.5625 9Z"
      fill="#3F3C43"
    />
    <path
      d="M12.4252 10.6875C12.1278 11.1998 11.7011 11.625 11.1878 11.9206C10.6745 12.2162 10.0925 12.3717 9.5002 12.3717C8.90785 12.3717 8.3259 12.2162 7.81257 11.9206C7.29925 11.625 6.87255 11.1998 6.5752 10.6875"
      stroke="#3F3C43"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Smile;
